// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // serverHost: 'developer-tv.radocc.com',
  serverPort: '8080',
  serverHost: 'server.versa.tv',
  // serverHost: 'ec2-54-233-13-210.sa-east-1.compute.amazonaws.com',
  // serverPort: '8080',
  // serverHost: '192.168.2.119',
  // serverPort: '8105',
  protocol: 'http',
  ws: 'ws'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
